import companysearchtemplate from './search.tpl.html';

import { getCompanies, isLoading, getTotal } from '../../../reducers/companies';

export class CompanySearch {
  constructor($scope, $ngRedux, actionsFactory, $translate, companiesService) {
    Object.assign(this, {
      $scope,
      $ngRedux,
      actionsFactory,
      $translate,
      companiesService,
      searchColumns: [
        {
          type: 'text',
          id: 'name',
          labelKey: 'TABLE_HEADER_NAME',
          sortable: true,
          width: '17%',
        },
        {
          id: 'clientCode',
          type: 'text',
          labelKey: 'COMPANY_CLIENTCODE',
          width: '13%',
        },
        {
          id: 'vatNumber',
          type: 'text',
          labelKey: 'COMPANY_VAT',
          width: '13%',
        },
        {
          type: 'text',
          id: 'country.name',
          labelKey: 'TABLE_HEADER_COUNTRY',
          width: '10%',
        },
        {
          type: 'text',
          id: 'type',
          transform: (column, element) => $translate.instant(element.isClient ? 'GENERIC_TYPE_CLIENT' : 'GENERIC_TYPE_NONCLIENT'),
          labelKey: 'TABLE_HEADER_TYPE',
          width: '10%',
        },
        {
          type: 'text',
          id: 'accountsCount',
          labelKey: 'TABLE_HEADER_ACCOUNTS_COUNT',
          width: '8%',
        },
        {
          type: 'text',
          id: 'ordersCount',
          labelKey: 'TABLE_HEADER_ORDERS_COUNT',
          width: '8%',
        },
        {
          type: 'text',
          id: 'inProgressOrdersCount',
          labelKey: 'TABLE_HEADER_PENDING_ORDERS_COUNT',
          width: '13%',
        },
        {
          type: 'button',
          id: 'gotodetail',
          cssClass: 'tct-icon tct-icon__eye',
          width: '4%',
          onClick: id => this.goTo('authenticated.company.detail.documents', { id }),
        },
        {
          type: 'button',
          id: 'gotodetail',
          cssClass: 'tct-icon tct-icon__edit',
          width: '4%',
          onClick: id => this.showEditCompanyModal(id),
        },
      ],
      searchParams: [
        {
          searchKey: 'GENERIC_COMPANY',
          type: 'input',
          input: '',
          id: 'name',
        },
        {
          searchKey: 'GENERIC_TYPE',
          input: '',
          id: 'type',
          type: 'select',
          options: [
            {
              value: 'client',
              key: 'GENERIC_TYPE_CLIENT',
            },
            {
              value: 'noclient',
              key: 'GENERIC_TYPE_NONCLIENT',
            },
            {
              value: '',
              key: 'GENERIC_ANY',
            },
          ],
        },
        {
          searchKey: 'COMPANY_VAT',
          type: 'input',
          input: '',
          id: 'vatNumber',
        },
      ],
      showNewAgencyModal: false,
    });
    const unsubscribe = $ngRedux.connect(CompanySearch.mapStateToThis, actionsFactory)(this);
    $scope.$on('$destroy', unsubscribe);
  }

  $onInit() {
    this.search = {
      name: '',
      companyType: '',
      vat_number: '',
    };
    this.sort = {
      name: '',
      status: '',
      nusers: '',
      role: '',
      // insertedby: '',
    };
    this.paramList = {
      sort: this.sort,
      search: this.search,
    };

    this.reqCompanyList(this.paramList);
    this.showCompanyEdit = false;
  }

  static mapStateToThis(state) {
    return {
      auth: state.authentication,
      companies: {
        items: getCompanies(state),
        loading: isLoading(state),
        total: getTotal(state),
      },
    };
  }

  addAgency(agency) {
    this.hideNewAgencyModal();
    this.createCompany(agency);
  }

  goTo(dest, params) {
    this.state(dest, params);
  }

  doShowNewAgencyModal() {
    this.showNewAgencyModal = true;
  }

  hideNewAgencyModal() {
    this.showNewAgencyModal = false;
  }

  showEditCompanyModal(id) {
    this.showCompanyEdit = true;
    const company = this.companies.items.find(item => item.id === id);
    this.editCompany = Object.assign({}, company,
      { countryId: company.country && company.country.id });
  }

  closeEditCompanyModal() {
    this.showCompanyEdit = false;
    this.editCompany = {};
  }

  confirmEditCompany() {
    const editCompany = Object.assign({}, {
      name: this.editCompany.name,
      countryId: this.editCompany.countryId,
      vatNumber: this.editCompany.vatNumber,
      fiscalCode: this.editCompany.fiscalCode,
      reaNumber: this.editCompany.countryId === 'IT' ?
        this.editCompany.reaNumber :
        null,
      cciaa: this.editCompany.countryId === 'IT' ?
        this.editCompany.cciaa :
        null,
      duns: this.editCompany.countryId !== 'IT' ?
        this.editCompany.duns :
        null,
      registration_number: this.editCompany.countryId !== 'IT' ?
        this.editCompany.registrationNumber :
        null,
      clientCode: this.editCompany.clientCode,
    });
    this.editCompanyStart(this.editCompany.id, editCompany);
    this.showCompanyEdit = false;
  }
}

CompanySearch.$inject = [
  '$scope',
  '$ngRedux',
  'actionsFactory',
  '$translate',
  'companiesService',
];

export const companySearch = {
  template: companysearchtemplate,
  controller: CompanySearch,
};
